import { render, staticRenderFns } from "./AICread.vue?vue&type=template&id=48d4248b&scoped=true&"
import script from "./AICread.vue?vue&type=script&lang=js&"
export * from "./AICread.vue?vue&type=script&lang=js&"
import style0 from "./AICread.vue?vue&type=style&index=0&id=48d4248b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d4248b",
  null
  
)

export default component.exports